import React from 'react';
import TableItem from '../Table';
import LineChartItem from '../LineChartItem';
import LineAndBarCombinedChartItem from '../LineAndBarCombinedChartItem';

interface KPIsTabProps {
  companyData: any;
}

export default function KPIsTab({ companyData }: KPIsTabProps) {
  if (!companyData) return null;

  return (
    <div className="space-y-8 min-w-0">
      {/* Equity Investors KPIs */}
      {companyData.cfaer_total_grid && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Equity Investors KPIs</h3>
          <h4 className="text-base font-medium text-slate-700 mb-3">Cash Flow Available for Equity Redemption</h4>

          <TableItem table={companyData.cfaer_total_grid} head_bold={true} bold_column_indexes={[0]} />

          {companyData.cfaer_discounted_details_grid && (
            <div className="mt-4">
              <TableItem table={companyData.cfaer_discounted_details_grid} head_bold={true} bold_column_indexes={[0]} />
            </div>
          )}

          {companyData.cfaer_detail_grid && (
            <div className="mt-4">
              <TableItem table={companyData.cfaer_detail_grid} head_bold={true} bold_column_indexes={[0]} />
            </div>
          )}

          {companyData.cfaer_detail_grid_chart_data && (
            <div className="mt-6">
              <LineAndBarCombinedChartItem
                name="Cash to Equity"
                data_x={companyData.cfaer_detail_grid_chart_data.data['year']}
                data_y_line={companyData.cfaer_detail_grid_chart_data.data['Cumulative cash eq to eq']}
                data_y_bar={companyData.cfaer_detail_grid_chart_data.data['Cash eq to equity']}
                data_y_line_name="Cumulative cash for equity to equity"
                data_y_bar_name="Cash for equity to equity"
              />
            </div>
          )}
        </section>
      )}

      {/* Lenders KPIs */}
      {companyData.lenders_key_performance_indicators && companyData.lenders_key_performance_indicators.length > 0 && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Lenders KPIs</h3>

          <div className="space-y-6">
            {companyData.lenders_key_performance_indicators.map((lender_kpi: any, index: number) => (
              <div key={index} className="border-t border-slate-100 pt-6 first:border-t-0 first:pt-0">
                <h4 className="text-base font-medium text-slate-700 mb-4">{lender_kpi.debt_name}</h4>

                {lender_kpi.cfads_details && (
                  <TableItem table={lender_kpi.cfads_details} head_bold={true} bold_column_indexes={[0]} />
                )}

                {lender_kpi.dscr && (
                  <div className="mt-4">
                    <TableItem table={lender_kpi.dscr} head_bold={true} bold_column_indexes={[0]} />
                  </div>
                )}

                {lender_kpi.dscr_llcr_chart_data && (
                  <div className="mt-6">
                    <LineChartItem
                      name="DSCR / LLCR / PLCR"
                      x_axis={lender_kpi.dscr_llcr_chart_data.x_axis}
                      data={lender_kpi.dscr_llcr_chart_data.data}
                      order={lender_kpi.dscr_llcr_chart_data.order}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Project KPIs */}
      {companyData.project_valuation && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Project KPIs</h3>

          <h4 className="text-base font-medium text-slate-700 mb-3">Valuation</h4>
          <TableItem table={companyData.project_valuation} head_bold={false} bold_column_indexes={[0]} />

          {companyData.project_valuation_details && (
            <div className="mt-6">
              <h4 className="text-base font-medium text-slate-700 mb-3">Cash Flow Available for Debt Service</h4>
              <TableItem table={companyData.project_valuation_details} head_bold={true} bold_column_indexes={[0]} />
            </div>
          )}
        </section>
      )}
    </div>
  );
}
